export default __webpack_public_path__ + "static/media/underline-payment.47db033b.svg";